module.exports = __webpack_public_path__ + "static/c1_image-e24e3673f0b9d27dabc8ab8ee574f35f.png";